import {
  ClientCuisine,
  GuestJourneyBenchmarkCuisine,
} from '../client-domain.types';

/**
 * BE `GET incentivio-client-domain/guest-journey/cuisine` — the cuisine used as
 * the Guest Journey Benchmarks comparison baseline (seeds the `benchmarkCuisine`
 * filter default) plus the cuisine-derived churn boundary.
 */
export const clientCuisine: ClientCuisine = {
  cuisine: 'mexican',
  displayTitle: 'Mexican',
  churnBoundaryDays: 90,
};

/**
 * BE `GET incentivio-client-domain/clients/cuisine/list` — the cuisine
 * categories the brand can benchmark against. `{ displayLabel, cuisine }` pairs
 * (sc-371637): `displayLabel` is the properly-cased option label, `cuisine` the
 * slug sent as `benchmarkCuisine`. `mexican` matches `clientCuisine.cuisine`, so
 * it seeds the filter default.
 */
export const benchmarkCuisinesFixture: GuestJourneyBenchmarkCuisine[] = [
  { displayLabel: 'Mexican', cuisine: 'mexican' },
  { displayLabel: 'Fast Casual', cuisine: 'fast_casual' },
  { displayLabel: 'QSR', cuisine: 'qsr' },
  { displayLabel: 'Café', cuisine: 'cafe' },
  { displayLabel: 'Casual Dining', cuisine: 'casual_dining' },
  { displayLabel: 'Pizza', cuisine: 'pizza' },
];
